<template>
    <div class="topcode-wechat-alarm-item" @click="handleClick">
        <div class="top">
            <div class="flex-center-y time ">{{info.time}}</div>
            <div :class="'flex-center-y auto-width-8 level  event-type-'+info.eventType">{{alarmLevelDICT}}</div>
            <div :class="'flex-center-y auto-width-8 state device-alarm-state-'+info.state">{{alarmStateDICT}}</div>
        </div>
        <div class="body">
            <div class="content">
                <div class="flex-center-y left">
                    <img :src="downloadImg + info.productImage1"/>
                    <div class="name">
                        <div>{{info.deviceName}}</div>
                        <div>{{info.productName}}</div>
                    </div>
                </div>
                <div class="flex-center right">
                    详情
                    <van-icon name="arrow"/>
                </div>
            </div>
            <div class="footer">
                <div class="row" style="font-size: 14px"><label>告警名称</label><span
                        style="color: #f5222d">{{info.eventName}}</span></div>
                <div class="row" style="font-size: 14px;"><label>发生时间</label><span>{{info.time}}</span></div>
                <div class="row" style="font-size: 14px;"><label>附加数据</label>
                    <span><div v-for="(param,index) in info.params" :key="index"
                               style="border: 1px solid #000; display: inline-block;
                                        border-radius: 5px; margin-right: 8px; margin-bottom: 5px; padding: 0 3px                                    ">
                        {{`${param.name} :${param.value}`}}
                    </div></span>
                </div>
                <div class="row"><label>设备编号</label><span>{{info.deviceSn}}</span></div>
                <div class="row"><label>所属单位</label><span>{{info.unitName}}</span></div>
                <div class="row"><label>安装位置</label><span>{{info.installLocation}}</span></div>
            </div>
        </div>

    </div>
</template>

<script>
    import {Cell, CellGroup, Icon, Tag} from "vant";
    import {downloadImg} from "@/config"
    import {setUnitId} from "@/utils/deviceId2unitId"

    export default {
        components: {
            Icon,
            CellGroup,
            Cell,
            Tag
        },
        props: {
            info: {type: Object, required: true},
            type: {type: String, required: true}
        },
        data() {
            return {
                downloadImg
            };
        },
        computed: {
            alarmLevelDICT() {
                return this.$DICT.getValue('EVENT_TYPE', this.info.eventType)
            },
            alarmStateDICT() {
                return this.$DICT.getValue('DEVICE_ALARM_STATE', this.info.state)
            },
        },
        created() {
        },
        mounted() {
        },
        methods: {
            handleClick() {
                setUnitId(this.info.deviceId, this.info.unitId)
                // this.$toast.fail("权限不足，请联系管理员");
                if (this.info.state == "UnHandle") {
                    return this.$router.push('/alarm/alarmDeal/' + this.info.deviceId)
                } else {
                    return this.$router.push('/alarm/alarmDetail/' + this.info.id + "/" + this.info.deviceId)
                }
            },
        },
        watch: {}
    };
</script>

<style lang="less" scoped>
    .topcode-wechat-alarm-item {
        width: 100%;
        /*height: 225px;*/
        padding-bottom: 3px;
        margin-bottom: 8px;
        border-radius: 8px;
        border: 1px #cccccc solid;
        background: e8e8e8;
        /*background: #51c332;*/

        & > .top {
            color: #fff;
            display: flex;
            height: 28px;
            border-radius: 8px 8px 0px 0px;
            background: #7e7e7e;
            & > .time {
                &::before {
                    width: 8px;
                    content: '';
                }
                height: 100%;
                width: 100%;
                justify-content: flex-start;

            }
            & > .level {
                height: 100%;
                /*width: 85px;*/
                justify-content: center;
            }
            & > .state {
                height: 100%;
                /*width: 75px;*/
                border-radius: 0px 8px 0px 0px;
                justify-content: center;
            }
        }
        & > .body {
            display: flex;
            flex-direction: column;
            & > .content {
                display: flex;
                /*padding: 8px;*/
                width: 100%;
                & > .left {
                    padding: 5px;
                    display: flex;
                    width: 100%;
                    /*background: #5cd8bc;*/
                    & > img {
                        width: 55px;
                        height: 55px;
                        background: #cccccc;
                        //border-radius: 8px;
                    }
                    & > .name {
                        padding-left: 20px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        /*background: #7e7e7e;*/
                        flex-direction: column;

                        & > div {
                            line-height: 1.5;

                        }

                    }
                }
                & > .right {
                    width: 75px;
                    color: #fa7d2d;
                    font-size: 14px;
                    font-weight: 500;
                }
            }
            & > .footer {
                padding: 0 3px 5px;
                & > .row {
                    display: flex;
                    line-height: 1.5;
                    padding-left: 10px;
                    /*align-items: center;*/
                    & > label {
                        width: 75px;
                        flex-shrink: 0;
                        &::after {
                            margin-left: 2px;
                            content: '：';
                        }
                    }
                    & > span {
                    }
                }
            }
        }
    }
</style>
